var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-startPractice" }, [
    _c(
      "div",
      { staticClass: "leftBox" },
      [
        _c("Title", { attrs: { text: "我的收藏" } }, [
          _c("i", {
            staticClass: "iconfont iconfanhui icon-back",
            attrs: { slot: "right" },
            on: {
              click: function ($event) {
                return _vm.$router.push({ name: "myCollect" })
              },
            },
            slot: "right",
          }),
        ]),
        _c(
          "ul",
          _vm._l(_vm.datas, function (item) {
            return _c("li", { key: item.id, staticClass: "mat10" }, [
              item.question_style !== 6
                ? _c(
                    "div",
                    [
                      _c(
                        "el-collapse",
                        {
                          model: {
                            value: _vm.activeNames,
                            callback: function ($$v) {
                              _vm.activeNames = $$v
                            },
                            expression: "activeNames",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "question-collapse-item",
                              attrs: { name: item.question_id },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "primary mar10",
                                    staticStyle: { "align-self": "flex-start" },
                                  },
                                  [
                                    _vm._v(
                                      "[" + _vm._s(item.question_title) + "]"
                                    ),
                                  ]
                                ),
                                _c("span", { staticStyle: { flex: "1" } }, [
                                  _vm._v(
                                    _vm._s(_vm.textLength(item.title, item.id))
                                  ),
                                ]),
                              ]),
                              item.question_style === 4
                                ? _c("FillBlank", {
                                    attrs: {
                                      datas: item,
                                      isDisabled: _vm.isDisabled,
                                    },
                                  })
                                : _vm._e(),
                              item.question_style === 1
                                ? _c("ChoiceOne", {
                                    attrs: {
                                      datas: item,
                                      isDisabled: _vm.isDisabled,
                                    },
                                  })
                                : _vm._e(),
                              item.question_style === 3
                                ? _c("ChoiceMultiple", {
                                    attrs: {
                                      datas: item,
                                      isDisabled: _vm.isDisabled,
                                    },
                                  })
                                : _vm._e(),
                              item.question_style === 2
                                ? _c("Judge", {
                                    attrs: {
                                      datas: item,
                                      isDisabled: _vm.isDisabled,
                                    },
                                  })
                                : _vm._e(),
                              item.question_style === 5
                                ? _c("Subjective", {
                                    attrs: {
                                      datas: item,
                                      isDisabled: _vm.isDisabled,
                                    },
                                  })
                                : _vm._e(),
                              _c("div", { staticClass: "submit mat20" }, [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.cancelCollect(
                                          item.question_id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.is_collect ? "取消收藏" : "收藏"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c("QuestionAnalysis", {
                                attrs: {
                                  analysisDatas: item,
                                  showNotes: true,
                                  isCollect: { is_true: true },
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          }),
          0
        ),
        _vm.datas.length == 0
          ? _c("ComponentEmpty", { attrs: { title: "暂无收藏", tips: "" } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }